<template>
  <div
    :style="{
      width: '100%',
      height: `${screeHeight}px`,
      overflow: 'hidden',
      backgroundImage: 'url(' + (bgContent ? bgContent : '') + ')',
      backgroundSize: '100% 100%',
    }"
  >
    <div id="special-subject" style="overflow-y: auto; height: 100%">
      <div>
        <div class="main">
          <div v-if="float.topFloat != ''" :class="{ floatTop: showFloatTop }">
            <img
              :src="float.topFloat.src"
              @click="handleUrl(item.url)"
              style="width: 100%"
            />
          </div>
          <div v-if="float.sideFloat.src" class="floatSide">
            <img
              :src="float.sideFloat.src"
              @click="handleFloatSide()"
              style="width: 60px; height: 60px"
            />
          </div>
          <div v-for="(item, index) in content.functionContent" :key="index">
            <div v-if="item.type == 'image'" style="margin-bottom: 4px">
              <div v-if="item.list.length == 1">
                <img
                  v-for="(childItem, key) in item.list"
                  :key="key"
                  :src="childItem.src"
                  @click="handleUrl(childItem.url)"
                  style="width: 100%"
                />
              </div>
              <div v-if="item.list.length == 2">
                <img
                  v-for="(childItem, key) in item.list"
                  :key="key"
                  :src="childItem.src"
                  @click="handleUrl(childItem.url)"
                  style="width: 49%"
                />
              </div>
              <div v-if="item.list.length == 3">
                <img
                  v-for="(childItem, key) in item.list"
                  :key="key"
                  :src="childItem.src"
                  @click="handleUrl(childItem.url)"
                  style="width: 33%"
                />
              </div>
              <div
                v-if="item.list.length == 4"
                style="display: flex; flex-wrap: wrap"
              >
                <img
                  v-for="(childItem, key) in item.list"
                  :key="key"
                  :src="childItem.src"
                  @click="handleUrl(childItem.url)"
                  style="width: 50%; display: block"
                />
              </div>
            </div>
            <div
              style="cursor: pointer; width: 100%; padding-left: 10px"
              v-if="item.type == 'text'"
              @click="handleUrl(item.link)"
              v-html="item.content"
            />
            <div
              v-if="item.type == 'livePlay'"
              :style="{
                display: 'flex',
                position: 'relative',
                'justify-content': 'center',
                'align-items': 'center',
                margin: '10px',
              }"
            >
              <livesItem
                :id="item.list[0].id"
                getType="live"
                :style="{
                  width: '1050px',
                  margin: 'auto',
                  border:
                    item.showBorder == 2
                      ? '2px solid #FFF'
                      : item.showBorder == 1
                      ? '2px solid #000'
                      : '0px',
                }"
              />
              <div
                v-if="
                  item.list[0].status != 'RESERVATION' &&
                  !item.list[0].showPlayNumber
                "
                style="
                  position: absolute;
                  top: 40px;
                  left: 20px;
                  z-index: 22;
                  font-size: 12px;
                  background-color: rgba(0, 0, 0, 0.4);
                  color: #fff;
                  border-radius: 10px;
                  padding: 4px 10px;
                "
              >
                <img
                  src="@/assets/img/eye.png"
                  alt="logo"
                  style="width: 18px; height: 10px"
                />
                <span style="margin-left: 10px; margin-top: -3px">{{
                  item.list[0].playNumber | filterData
                }}</span>
              </div>
            </div>
            <div
              v-if="item.type == 'livesList'"
              style="
                position: relative;
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
              "
            >
              <img
                :key="key"
                @click="goToDetail('live', childItem.id)"
                v-for="(childItem, key) in item.list"
                :src="childItem.cover"
                :style="{
                  border:
                    item.showBorder == 2
                      ? '2px solid #FFF'
                      : item.showBorder == 1
                      ? '2px solid #000'
                      : '0px',
                  width: 'calc(50% - 20px)',
                  marginLeft: key % 2 == 1 ? '10px' : '0px',
                  marginBottom: '5px',
                  height: '98px',
                }"
              />
            </div>
            <div
              v-if="item.type == 'videoPlay'"
              :style="{
                display: 'flex',
                margin: '10px',
                'justify-content': 'center',
                'align-items': 'center',
              }"
            >
              <video
                :src="item.list[0].url"
                :poster="item.list[0].cover"
                style="width: 100%"
                controls
              ></video>
            </div>
            <div
              v-if="item.type == 'videosList'"
              :style="{
                display: 'flex',
                'justify-content': 'center',
                'align-items': 'center',
              }"
            >
              <videosItem :newsList="item.list" :showBorder="item.showBorder" />
            </div>
            <div v-if="item.type == 'newsList'">
              <newsItem :newsList="item.list" :showBorder="item.showBorder" />
            </div>
            <div v-if="item.type == 'newReader'" style="margin: 20px 10px">
              <div :key="key" v-for="(childItem, key) in item.list">
                <newReader
                  :id="childItem.id"
                  :style="{
                    border:
                      item.showBorder == 2
                        ? '2px solid #FFF'
                        : item.showBorder == 1
                        ? '2px solid #000'
                        : '0px',
                  }"
                />
              </div>
            </div>
            <div
              v-if="item.type == 'authUser'"
              style="padding: 10px 0px; text-align: center"
            >
              <div :key="key" v-for="(childItem, key) in item.list">
                <img
                  :src="childItem.avatar"
                  style="width: 180px; height: 180px"
                />
                <div>{{ childItem.username }}</div>
                <div
                  @click="goToDownload"
                  style="
                    background-color: rgba(242, 242, 242, 1);
                    cursor: pointer;
                    width: 126px;
                    height: 39px;
                    line-height: 39px;
                    border-radius: 10px;
                    margin: 20px auto;
                  "
                >
                  +关注
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <comment :id="subjectId" v-if="isShowSubject" style="background: #fff" />
      <div
        v-if="float.middleFloat != '' && isShowMiddleFloat"
        style="
          text-align: center;
          position: fixed;
          top: calc(50% - 100px);
          z-index: 999999999;
          width: 100%;
        "
      >
        <div
          style="
            position: absolute;
            right: 20px;
            top: -40px;
            color: #333333;
            cursor: pointer;
          "
          @click="handleShowMiddleFloat"
        >
          <div
            style="
              background: rgba(85, 85, 85, 0.7);
              color: #fff;
              width: 30px;
              height: 30px;
              line-height: 30px;
              border-radius: 15px;
            "
          >
            X
          </div>
        </div>
        <img
          :src="float.middleFloat.src"
          @click="handleUrl(float.middleFloat.url)"
          style="width: 200px; margin: auto; height: 200px"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SpecialItem from "@/components/subject/special-item";
import newsItem from "@/components/subject/news";
import videosItem from "@/components/subject/videos";
import livesItem from "@/components/subject/lives";
import newReader from "@/components/subject/newReader";

import comment from "@/components/subject/comment";
import { getResourceSubjectsDetail } from "@/utils/request.js";
import { getImageURL as _getImageURL } from "@/utils/zgly-utils.js";

export default {
  head() {
    return {
      title: `${this.specials.title ? this.specials.title : "专题"}-`,
      meta: [
        {
          hid: "description",
          name: "description",
          content: `${
            this.specials.description
              ? this.specials.description.replace(new RegExp("<.+?>", "g"), "")
              : "中国旅游影视传媒有限公司(中国旅游TV，英文简称CTTV)是在中国旅游局监督指导下，信息产业部、商务部、文化部大 力支持下成立的“互联网+旅游”专业综合平台。中国旅游TV始终坚持开拓多 渠道集群发展产业链与多环节增值的完整生态运作体系，立足于移动互联网， 秉持大盘运作的运营理念，借助资深创意策划以及媒体集团联盟优势，打造集 在线视频、网络直播、线上旅游、城市宣传、生活服务、信息集散、全景VR等 功 能于一体的新型旅游综合门户平台。"
          }`,
        },
      ],
    };
  },
  components: {
    SpecialItem,
    newsItem,
    livesItem,
    videosItem,
    comment,
    newReader
  },
  filters: {
    filterData(val) {
      return val > 10000 ? `${(val / 10000).toFixed(2)}万` : val;
    },
  },
  data() {
    return {
      // 专题条目
      screeHeight: "", // 屏幕高
      specials: {},
      content: {
        frameContent: [],
        functionContent: [],
      },
      bgContent: "",
      subjectId: "",
      showFloatTop: false,
      isShowSubject: false,
      isShowMiddleFloat: false,
      float: {
        topFloat: {},
        sideFloat: {},
        middleFloat: {},
      },
    };
  },
  mounted() {
    this.screeHeight = document.documentElement.clientHeight;
    this.subjectId = this.$route.params.id + "";
    this.isShowSubject = true;
    this.querySubjectInfo(this.id);
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop; // 滚动条偏移量
      this.showFloatTop = scrollTop > 60 ? true : false; // 如果滚动到顶部了，this.isFixed就为true
    },
    handleUrl(url) {
      if (url) {
        window.location.href = url;
      }
    },
    handleFloatSide() {
      if (this.float.sideFloat.backTop) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      } else {
        this.handleUrl(this.float.sideFloat.url);
      }
    },
    getImageURL(cover) {
      return _getImageURL(cover);
    },
    // 查询专题
    querySubjectInfo() {
      getResourceSubjectsDetail(this.subjectId).then((res) => {
        this.specials = res.data;

        this.content = JSON.parse(this.specials.content);
 
        this.content.frameContent.forEach((element) => {
          if (element.type == "bcImage") {
            this.bgContent = element.src;
          }
          if (element.type == "topFloat") {
            this.float.topFloat = element;
          }
          if (element.type == "sideFloat") {
            this.float.sideFloat = element;
          }
          if (element.type == "middleFloat") {
            this.float.middleFloat = element;
            this.isShowMiddleFloat = true;
          }
        });
      });
    },
    goToDetail(type, id) {
      if (type == "live") {
        this.$router.push({ path: `/live/player/${id}` });
      }
    },
    goToDownload() {
      this.$router.push({ path: `/download` });
    },
    handleShowMiddleFloat() {
      this.isShowMiddleFloat = false;
    },
  },
};
</script>

<style lang="less" scope>
#special-subject {
  .main {
    width: 100%;
    margin: 0px auto 10px;
    .floatTop {
      position: fixed;
      width: 100%;
      z-index: 9999;
      top: 0px;
    }
    .floatSide {
      position: fixed;
      z-index: 9999;
      bottom: 60px;
      right: 30px;
    }
    .list-box .item {
      width: 46%;
      margin: 1rem 2%;
    }
  }
}
</style>

